import React, { useRef, useEffect, forwardRef } from 'react'
import QRCode from 'easyqrcodejs'
import logo from '../assets/logo.png'

const QR = forwardRef(({ id }, ref) => {
  const qrcode = useRef(null)

  useEffect(() => {
    if (!qrcode.current) return

    qrcode.current.innerHTML = ""

    const options = {
      text: `https://bebbo.mx/?id=${id}`,
      width: 400,
      height: 400,
      // colorLight: "rgba(209, 254, 135, 1)",
      // colorDark: "rgba(35, 75, 74, 1)",
      correctLevel: QRCode.CorrectLevel.H,
      // logo,
      // logoWidth: 130,
      // logoHeight: 100,
      // logoBackgroundTransparent: true
    }

    new QRCode(qrcode.current, options)

    if (ref) ref.current = qrcode.current
  }, [id])

  return <div ref={qrcode} />
})

export default QR